import './index.css';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';



// Pages publiques
import Login from './pages/Login';

// Pages agent
import Dashboard from './pages/Dashboard';
import Promotions from './pages/Promotions';
import Modules from './pages/Modules';
import ModuleDetail from './pages/ModuleDetail';
import Quiz from './pages/Quiz';
import QuizSelect from './pages/QuizSelect';
import Simulations from './pages/Simulations';
import Profile from './pages/Profile';

// Pages formateur
import FormateurDashboard from './pages/formateur/Dashboard';
import FormateurProfile from './pages/formateur/Profile';
import UserProfile from './pages/formateur/UserProfile';
import FormateurProducts from './pages/formateur/Products';
import FormateurPromotions from './pages/formateur/Promotions';
import SimulationRequests from './pages/formateur/Simulation';

// Pages admin
import AdminDashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminPromotions from './pages/admin/Promotions';
import AdminUsers from './pages/admin/Users';
import AdminStats from './pages/admin/Stats';
import AdminModules from './pages/admin/Modules';
import AdminSimulations from './pages/admin/Simulations';

function App() {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/login" element={<Login />} />

      {/* Routes protégées - Agent */}
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="promotions/:promotionId/modules" element={<Modules />} />
        <Route path="modules/:moduleId" element={<ModuleDetail />} />
        <Route path="quiz" element={<QuizSelect />} />
        <Route path="quiz/:promotionId" element={<Quiz />} />
        <Route path="simulations" element={<Simulations />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* Routes protégées - Admin */}
      <Route
        path="/admin"
        element={<ProtectedRoute requiredRole="admin"><Layout isAdmin /></ProtectedRoute>}
      >
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="promotions" element={<AdminPromotions />} />
        <Route path="simulations" element={<AdminSimulations />} />
		<Route path="modules" element={<AdminModules />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="stats" element={<AdminStats />} />
		<Route path="promotions/:promotionId/modules" element={<Modules />} />
		
      </Route>

      {/* Routes protégées - Formateur */}
      <Route
        path="/formateur"
        element={<ProtectedRoute requiredRole="formateur"><Layout isFormateur /></ProtectedRoute>}
      >
        <Route index element={<Navigate to="/formateur/dashboard" replace />} />
        <Route path="dashboard" element={<FormateurDashboard />} />
        <Route path="products" element={<FormateurProducts />} />
          <Route path="promotions" element={<FormateurPromotions />} />
          <Route path="promotions/:promotionId/modules" element={<Modules />} />
        <Route path="simulation" element={<SimulationRequests />} />
        <Route path="profile" element={<FormateurProfile />} />
        <Route path="users/:userId" element={<UserProfile />} />
        <Route path="users" element={<AdminUsers />} />
      </Route>


	  <Route path="/modules/:promotionId" element={<Modules />} />
	  
    </Routes>
  );
}

export default App;
